<template>
  <div class="g-bnc-pay">
    <div class="m-bnc-p2p" v-if="payMode.includes('BncEnLinea_P2P')">
      <div class="u-brand-info">
        <div class="u-brand-info-title">
          {{ bncPay.p2p_title }}
          <span class="u-brand-info-copy" @click="onBrandCopy(brandInfo)">
            {{ bncPay.copy_all }}
          </span>
        </div>
        <div class="u-brand-info-list">
          <div
            class="u-brand-info-item"
            v-for="(value, key) in brandInfo"
            :key="key"
          >
            <span class="u-brand-info-label">{{ key }}:</span>
            <span class="u-brand-info-value">{{ value }}</span>
          </div>
        </div>
      </div>
      <van-row class="u-bnc-pay p2p-card-form">
        <div class="card-dropdown">
          <van-dropdown-menu>
            <van-dropdown-item
              :options="bankCodeList"
              v-model="p2pCard.BankCode"
            />
          </van-dropdown-menu>
        </div>
        <van-field
          type="number"
          :placeholder="bncPay.phone_number"
          v-model="p2pCard.PhoneNumber"
          class="p2p-field"
        />
        <van-col>
          <van-col span="10">
            <van-field
              type="number"
              :placeholder="bncPay.reference"
              v-model="p2pCard.Reference"
              class="p2p-field"
          /></van-col>
          <van-col span="2"></van-col>
          <van-col span="12">
            <van-field
              readonly
              clickable
              :placeholder="bncPay.request_date"
              :value="p2pCard.RequestDate"
              @click="openDatePicker('date')"
              class="p2p-field"
            />
          </van-col>
        </van-col>
      </van-row>
    </div>
    <div class="m-bnc-vpos" v-if="payMode.includes('BncEnLinea_VPOS')">
      <van-row class="u-bnc-pay vpos-card-form">
        <div class="card-dropdown">
          <van-dropdown-menu>
            <van-dropdown-item
              :options="cardTypeItems"
              v-model="vposCard.idCardType"
            />
          </van-dropdown-menu>
        </div>
        <van-field
          type="number"
          :placeholder="bncPay.card_holder_id"
          v-model="vposCard.CardHolderID"
          class="vpos-field"
        />
        <van-field
          type="text"
          :placeholder="bncPay.card_holder_name"
          v-model="vposCard.CardHolderName"
          class="vpos-field"
        />
        <van-field
          type="number"
          :placeholder="bncPay.card_number"
          v-model="vposCard.CardNumber"
          class="vpos-field"
        />
        <van-row class="vpos-row">
          <van-col span="11">
            <van-field
              readonly
              clickable
              :placeholder="bncPay.expiry_date"
              :value="vposCard.dtExpiration"
              @click="openDatePicker('year-month')"
            />
          </van-col>
          <van-col span="1"></van-col>
          <van-col span="12">
            <van-field
              type="number"
              maxlength="6"
              :placeholder="bncPay.cvv"
              v-model="vposCard.CVV"
              class="vpos-field"
            />
          </van-col>
        </van-row>
        <van-field
          type="number"
          :placeholder="bncPay.card_pin"
          v-model="vposCard.CardPIN"
          class="vpos-field"
        />
      </van-row>
    </div>
    <div class="u-bnc-pay">
      <van-row class="vpos-btns">
        <van-col span="12">
          <van-button
            type="default"
            size="large"
            class="vpos-btn-cancel"
            @click="onCancel"
          >
            {{ bncPay.cancel }}
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="primary"
            size="large"
            class="vpos-btn-submit"
            @click="onSubmit"
          >
            {{ bncPay.confirm }}
          </van-button>
        </van-col>
      </van-row>
    </div>

    <!-- 日期选择弹窗 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="pickerValue"
        :type="pickerType"
        :min-date="pickerType === 'year-month' ? expiryMinDate : minDate"
        @confirm="onPickerConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import multicurrencyMixin from "../../mixins/multicurrency";
export default {
  name: "SaveCardPay",
  mixins: [multicurrencyMixin],
  components: {},
  computed: {
    ...mapState(["system", "user"]),
    i18n() {
      return this.$t("confirm");
    },
    bncPay() {
      return this.$t("bncPay");
    },
    payMode() {
      return this.Query && this.Query.payMode;
    },
    cardTypeItems() {
      return [
        { value: 1, text: this.bncPay.visa || "VISA" },
        { value: 2, text: this.bncPay.master_card || "Master Card" },
        { value: 3, text: this.bncPay.master_debit || "Master Debit" }
      ];
    }
  },
  data() {
    return {
      areaCode: "58",
      showDatePicker: false,
      pickerType: "date",
      minDate: new Date(2000, 0, 1),
      expiryMinDate: new Date(2000, 0, 1),
      pickerValue: new Date(),
      brandInfo: {
        RIF: "J-501243743",
        Teléfono: "04125818250",
        Banco: "BNC(0191)"
      },
      p2pCard: {
        BankCode: 0,
        PhoneNumber: "",
        Reference: "",
        RequestDate: ""
      },
      vposCard: {
        idCardType: 1,
        CardPIN: "",
        CardHolderID: "",
        CardHolderName: "",
        CardNumber: "",
        dtExpiration: "",
        CVV: ""
      },
      bankCodeList: []
    };
  },
  methods: {
    // SaveCardPay 支付
    SaveCardPay(done) {
      if (this.payMode.includes("BncEnLinea_VPOS")) {
        // VPOS 信用卡模式验证
        const card = this.vposCard;
        if (!card.idCardType) {
          this.$toast(this.bncPay.please_select_card_type);
        } else if (!card.CardHolderID) {
          this.$toast(this.bncPay.please_enter_holder_id);
        } else if (!card.CardHolderName) {
          this.$toast(this.bncPay.please_enter_holder_name);
        } else if (!card.CardNumber) {
          this.$toast(this.bncPay.please_enter_card_number);
        } else if (!card.dtExpiration) {
          this.$toast(this.bncPay.please_enter_expiry);
        } else if (!card.CVV) {
          this.$toast(this.bncPay.please_enter_cvv);
        } else {
          card.dtExpiration = card.dtExpiration.replace(/-/g, "");
          this.$store.commit("bncCardInfo", { ...card });
          this.onCancel("barck");
        }
      } else {
        // P2P 模式验证
        const p2p = this.p2pCard;
        if (!p2p.BankCode) {
          this.$toast(this.bncPay.please_select_bank);
        } else if (!p2p.PhoneNumber) {
          this.$toast(this.bncPay.please_enter_phone);
        } else if (!p2p.Reference) {
          this.$toast(this.bncPay.please_enter_reference);
        } else if (!p2p.RequestDate) {
          this.$toast(this.bncPay.please_enter_date);
        } else {
          p2p.BankCode = parseInt(p2p.BankCode);
          p2p.PhoneNumber = `${this.areaCode}${p2p.PhoneNumber}`;
          this.$store.commit("bncCardInfo", { ...p2p });
          this.onCancel("barck");
        }
      }
    },
    // 确认支付
    onPayment(action, done) {
      if (action === "confirm") {
        this.SaveCardPay(done);
      } else if (action === "cancel") {
        this.$emit("onPayment", { show: false, cancel: true });
        done();
      }
    },
    // 加载BankCode列表
    async loadBankCodeList(paymentId) {
      this.$loading(true);
      var res = await this.multicurrencyBanks(paymentId);
      this.$loading(false);
      if (this.payMode === res.paymentType && res.bankList) {
        var bankCodeList = res.bankList.map(item => {
          return { value: item.Code, text: `${item.Name}(${item.Code})` };
        });
        bankCodeList.unshift({
          value: 0,
          text: this.bncPay.please_select || "Please select"
        });
        this.bankCodeList = bankCodeList;
      }
    },
    // 取消支付
    onCancel(type) {
      if (!type) {
        this.$store.commit("bncCardInfo", {});
      }
      this.$nextTick(() => {
        this.$router.go(-1);
      });
    },
    // 提交支付
    onSubmit() {
      this.SaveCardPay(() => {});
    },
    // 复制内容
    onBrandCopy(value) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(JSON.stringify(value)).then(() => {
          this.$toast(this.bncPay.copied);
        });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = JSON.stringify(value);
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast(this.bncPay.copied);
      }
    },
    // 打开日期选择器
    openDatePicker(type) {
      this.pickerType = type;
      this.pickerValue = new Date();
      this.showDatePicker = true;
    },
    // 日期选择确认
    onPickerConfirm(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      if (this.pickerType === "year-month") {
        this.vposCard.dtExpiration = `${month}-${year}`;
      } else {
        const day = String(date.getDate()).padStart(2, "0");
        this.p2pCard.RequestDate = `${year}/${month}/${day}`;
      }
      this.showDatePicker = false;
    }
  },
  mounted() {},
  created() {
    this.Query = this.$route.query;
    if (this.Query.payMode.includes("BncEnLinea_P2P")) {
      this.loadBankCodeList(this.Query.paymentId);
    }
  }
};
</script>

<style lang="less" scoped>
.u-bnc-pay {
  width: 90%;
  margin: 0 auto;
  padding: 64px 0 42px;
  .van-cell {
    border: 1px solid #ebedf0;
    border-radius: 12px;
  }
  &-card {
    margin: 28px 0;
  }
}
.vpos-card-form {
  .vpos-field {
    margin-bottom: 24px;
    .van-field__label {
      width: 140px;
      font-size: 28px;
      color: #333;
    }
    .van-field__control {
      font-size: 28px;
    }
  }
  .vpos-row {
    display: flex;
    justify-content: space-between;
    .van-col {
      padding: 0 8px;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
}
.p2p-card-form {
  .p2p-field {
    margin-bottom: 24px;
    .van-field__label {
      width: 140px;
      font-size: 28px;
      color: #333;
    }
    .van-field__control {
      font-size: 28px;
    }
  }
}
.card-dropdown {
  position: relative;
  margin: 0 auto 24px;
  .van-dropdown-item--down {
    top: 180px !important;
  }
}

.vpos-btns {
  margin-top: 40px;
  .van-col {
    padding: 0 8px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
  .vpos-btn-cancel {
    background-color: #ebedf0;
  }
  .vpos-btn-cancel,
  .vpos-btn-submit {
    border-radius: 12px;
    height: 88px;
    font-size: 32px;
  }
}
.u-brand-info {
  width: 90%;
  margin: 64px auto 0;
  padding: 30px;
  border-radius: 24px;
  background: #333;
  color: #fff;
  box-sizing: border-box;
  &-title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
  }
  &-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &-item {
    display: flex;
    align-items: center;
    font-size: 28px;
  }
  &-label {
    margin-right: 8px;
  }
  &-value {
    flex: 1;
  }
  &-copy {
    color: #1989fa;
    font-size: 28px;
    padding: 8px 16px;
  }
}
</style>
